import { token } from '@atlaskit/tokens';
import React from 'react';
import styled from 'styled-components';

import { type TextLikeFieldType } from '../types.ts';

import { type ViewComponentProps } from './types.ts';

const Container = styled.span<{
  showDisabledValue?: boolean;
}>`
  white-space: pre-wrap;
  color: ${({ showDisabledValue }) =>
    showDisabledValue ? token('color.text.disabled', '#8993A4') : 'inherit'};
`;

function TextValueView<Type extends TextLikeFieldType>({
  value,
  showDisabledValue
}: ViewComponentProps<Type>) {
  return <Container showDisabledValue={showDisabledValue}>{value.plain}</Container>;
}

export default TextValueView;
